import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

const infoHeadTitleList = [
  {
    headTitle: "出産日",
  },
  {
    headTitle: "育児休業開始日",
  },
  {
    headTitle: "育児休業終了日",
  },
  {
    headTitle: "パパママ育休プラス",
  },
  {
    headTitle: "産後パパ育休",
  },
  {
    headTitle: "半年延長の理由",
  },
];

const transferHeadTitleList = [
  {
    headTitle: "異動内容",
  },
  {
    headTitle: "異動日",
  },
  {
    headTitle: "職員番号",
  },
  {
    headTitle: "契約者",
  },
  {
    headTitle: "施設",
  },
];
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "契約者番号",
    keyword: "contractorNo",
    type: "text",
  },
  {
    title: "契約者名",
    keyword: "corpName",
    type: "text",
  },
  {
    title: "契約者住所",
    keyword: "corpAddress",
    type: "text",
  },
  {
    title: "TEL",
    keyword: "tel",
    type: "text",
  },
  {
    title: "FAX",
    keyword: "fax",
    type: "text",
  },
  {
    keyword: "title1",
    type: "lineTitle",
    lineTitle: "",
  },
  {
    title: "施設番号",
    keyword: "facilityNo",
    type: "text",
  },
  {
    title: "施設名",
    keyword: "facilityName",
    type: "text",
  },
  {
    title: "施設住所",
    keyword: "facilityAddress",
    type: "text",
  },
  {
    title: "施設種類",
    keyword: "name1",
    type: "text",
  },
  {
    title: "施設区分",
    keyword: "name2",
    type: "text",
  },
  {
    keyword: "title2",
    type: "lineTitle",
    lineTitle: "",
  },
  {
    title: "職員名",
    keyword: "staffNameKanji",
    type: "text",
  },
  {
    title: "性別",
    keyword: "sex",
    type: "text",
  },
  {
    title: "職種",
    keyword: "jobName",
    type: "text",
  },
  {
    title: "生年月日",
    keyword: "birthday",
    type: "text",
  },
  {
    title: "加入日",
    keyword: "joinDate",
    type: "text",
  },
  {
    title: "在籍期間",
    keyword: "enroll",
    type: "text",
  },
  {
    title: "退職日",
    keyword: "retireDate",
    type: "text",
  },
  {
    title: "俸給表の額",
    keyword: "salaryTableAmt",
    type: "text",
  },
  {
    title: "俸給の調整額",
    keyword: "salaryAdjustmentAmt",
    type: "text",
  },
  {
    title: "合計",
    keyword: "sun",
    type: "text",
  },
  {
    keyword: "title3",
    type: "lineTitle",
    lineTitle: "",
  },
  {
    title: "退職届提出日",
    keyword: "applyDate",
    type: "text",
  },
  {
    title: "支給額",
    keyword: "paymentAmt",
    type: "text",
  },
  {
    title: "送金予定日",
    keyword: "remitDueDate",
    type: "text",
  },
  {
    keyword: "title4",
    type: "lineTitle",
    lineTitle: "",
  },
  {
    title: "ならない月",
    keyword: "unrecognizedMonthList",
    type: "nodeInLine",
  },
  {
    title: "テーブル",
    keyword: "childcareLeaveList",
    type: "node",
  },
  {
    title: "異動履歴",
    keyword: "transferHistoryList",
    type: "node",
  },
];

export { fakeTableList, infoHeadTitleList, transferHeadTitleList };
